import { ApolloProvider } from '@apollo/client/react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { ThemeProvider } from '@/theme';
import { AppRouter } from '@/routes';
import { graphqlClient } from '@/services';
import { GlobalProvider } from '@/context';

function App() {
  return (
    <ApolloProvider client={graphqlClient}>
      <GlobalProvider>
        <ThemeProvider>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <AppRouter />
          </LocalizationProvider>
          <ToastContainer
            position="bottom-left"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop
            closeOnClick
            pauseOnHover
          />
        </ThemeProvider>
      </GlobalProvider>
    </ApolloProvider>
  );
}

export default App;
